<div class="modal">
    <header class="header">
        <div class="close-button" (click)="closeModal()">
            <i class="ju ju-close"></i>
        </div>
        <img class="title-icon"
             src="./assets/images/icons/icon-heated-gw.svg"/>
        <span class="title">Gatewayangaben Überprüfung</span>
    </header>
    <div class="modal-content" id="modal-content">
        <div class="refresh"
             fxLayoutAlign="center center"
             (click)="onGatewayRefreshBtnClicked()"
             [ngClass]="{ loading: isLoading, error: hasError }">
            <img src="./assets/images/icons/refresh.svg"/>
        </div>
        <div class="data-content"
             [ngClass]="{ 'no-valid-data': isLoading || hasError }">
            <div class="card" *ngIf="hasError && !refreshButtonClicked">
                <div class="error">
                    Beim Laden der Daten ist ein Fehler aufgetreten. Bitte klicken Sie
                    zum Wiederholen auf die Schaltfläche „Aktualisieren“.
                </div>
            </div>

            <div class="card" *ngIf="temperatureSensors?.length">
                <div class="card-title">Temperatur</div>
                <div class="card-content">
                    <ng-container *ngFor="let sensor of temperatureSensors">
                        <div class="sensor-row">
                            <div class="sensor-id">
                                ID {{ sensor.sensorId }}
                            </div>
                            <div class="sensor-name">
                                {{ getTemperatureSensorName(sensor.name) }}
                            </div>
                            <div class="sensor-value">
                                {{ getTemperatureSensorValue(sensor.value) }}
                            </div>
                        </div>
                        <div class="sensor-row" *ngIf="sensor.name2">
                            <div class="sensor-id">
                                ID {{ sensor.sensor2Id }}
                            </div>
                            <div class="sensor-name">
                                {{ getTemperatureSensorName(sensor.name2) }}
                            </div>
                            <div class="sensor-value">
                                {{ getTemperatureSensorValue(sensor.value2) }}
                            </div>
                        </div>
                        <div class="sensor-row" *ngIf="sensor.name3">
                            <div class="sensor-id">
                                ID {{ sensor.sensor3Id }}
                            </div>
                            <div class="sensor-name">
                                {{ getTemperatureSensorName(sensor.name3) }}
                            </div>
                            <div class="sensor-value">
                                {{ getTemperatureSensorValue(sensor.value3) }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="card" *ngIf="pumpSensors?.length">
                <div class="card-title">Pumpen</div>
                <div class="card-content">
                    <ng-container *ngFor="let sensor of pumpSensors">
                        <div class="sensor-row">
                            <div class="sensor-id">
                                ID {{ sensor.sensorId }}
                            </div>
                            <div class="sensor-name">
                                {{ getPumpSensorName(sensor.name) }}
                            </div>
                            <div class="sensor-value">
                                {{ getPumpSensorValue(sensor) }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Grenzwert</div>
                            <div class="value">
                                {{ sensor.minValue }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Sensorart</div>
                            <div class="value">
                                {{ sensor.sensorType }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Fabrikat</div>
                            <div class="value">
                                {{ sensor.pumpBrand }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Typ</div>
                            <div class="value">
                                {{ sensor.pumpType }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Elektronisch geregelt</div>
                            <div class="value">
                                {{ sensor.pumpElectronicallyControlled ? 'Ja' : 'Nein' }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="card" *ngIf="meterSensors?.length">
                <div class="card-title">Zähler</div>
                <div class="card-content">
                    <ng-container *ngFor="let sensor of meterSensors">
                        <div class="sensor-row">
                            <div class="label">{{ sensor.module }}.{{ sensor.sensorId }}</div>
                            <div class="key-value">
                                {{ getCounterSensorName(sensor.name) }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label" *ngIf="sensor.meterType === MeterTypeEnum.Impulse">Impuls</div>
                            <div class="label" *ngIf="sensor.meterType === MeterTypeEnum.IR">Wert</div>
                            <div class="key-value">
                                {{ sensor.value }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Seriennummer</div>
                            <div class="key-value">
                                {{ sensor.seriesNumber }}
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Hersteller</div>
                            <div class="key-value">
                                {{ sensor.manufacturer }}
                            </div>
                        </div>
                        <div class="sensor-row" *ngIf="sensor.meterType === MeterTypeEnum.Impulse">
                            <div class="label">Impuls pro Einheit</div>
                            <div class="key-value">
                                {{ sensor.impulse.stepInUnit }}
                            </div>
                        </div>
                        <div class="sensor-row" *ngIf="sensor.meterType === MeterTypeEnum.Impulse">
                            <div class="label">Aktueller Wert</div>
                            <div class="key-value">
                                {{ sensor.impulse.initOffset }}
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="card" *ngIf="otherSectionHasContent()">
                <div class="card-title">Sonstige</div>
                <div class="card-content">
                    <div class="sensor-row" *ngFor="let sensor of otherSensors; let i = index">
                        <div class="sensor-id">
                            Module ID {{ sensor.uvsModuleId }}
                        </div>
                        <div class="sensor-name">
                            {{ getOtherSensorName(sensor.sensorType) }}
                        </div>
                        <div class="sensor-value">
                                    <span *ngIf="sensor.sensorType === 'LIGHT'" class="warning-label"
                                          [ngClass]="{'error' : getModule(sensor.uvsModuleId)?.light[0] >= 100}">
                                        {{ getModule(sensor.uvsModuleId)?.light[0] ? getModule(sensor.uvsModuleId).light[0] : '-' }}
                                    </span>
                            <span>{{ sensor.sensorOn ? 'An' : 'Aus' }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="pressureSectionHasContent()">
                <div class="card" *ngFor="let sensor of pressureSensors; let i = index">
                    <div class="card-title">{{ 'Druck ' + sensor.sensorId }}</div>
                    <div class="card-content">
                        <div class="sensor-row">
                            <div class="label">Druck</div>
                            <div class="value">
                                {{ sensor.value }} bar
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Untergrenze Druck</div>
                            <div class="value">
                                {{ sensor.lowerLimit }} bar
                            </div>
                        </div>
                        <div class="sensor-row">
                            <div class="label">Obergrenze Druck</div>
                            <div class="value">
                                {{ sensor.upperLimit }} bar
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div class="card" *ngIf="pfcSensors?.length > 0">
                <div class="card-title">PFC</div>
                <div class="card-content">
                    <div class="sensor-row" *ngFor="let sensor of pfcSensors; let i = index">
                        <div class="sensor-id">
                            Module ID {{ sensor.uvsModuleId }}
                        </div>
                        <div class="sensor-name">
                            {{ getPfcSensorName(sensor.name) }}
                        </div>
                        <div class="sensor-value">
                            <span>{{ sensor.closed ? 'Schließer' : 'Öffner' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form class="popup-footer" #form="ngForm">

            <div class="bottom-footer-container">
                <div class="input-group">
                    <label for="comment">Allgemeiner Kommentar</label>
                    <textarea cols="30" rows="10" placeholder="Hier können Sie optionale Kommentare eingeben."
                              name="comment"
                              id="comment"
                              [(ngModel)]="shareService.generalSending.generalComment">
                            </textarea>
                </div>
            </div>

            <div class="verification-row">
                <app-input-check-box name="installationInSeveralRooms"
                                     [(ngModel)]="installationInSeveralRooms"
                                     required>
                    <span>Installation auf mehrere Räume verteilt.</span>
                </app-input-check-box>
            </div>

            <div class="measurement-section">
                <div class="footer-card">
                    <div class="footer-card-title">Aufmaß</div>
                    <div class="footer-card-content">
                        <div class="input-row">
                            <div>
                                NYM-Kabel
                            </div>
                            <div class="input-section">
                                <div>ca.</div>
                                <input type="number" name="nymCable" placeholder="NYM-Kabel"
                                       [(ngModel)]="commissioningMaterial.nymCable">
                                <div class="input-unit">m</div>
                            </div>
                        </div>
                        <div class="input-row">
                            <div>
                                Steuerkabel
                            </div>
                            <div class="input-section">
                                <div>ca.</div>
                                <input type="number" name="controlCable" placeholder="Steuerkabel"
                                       [(ngModel)]="commissioningMaterial.controlCable">
                                <div class="input-unit">m</div>
                            </div>
                        </div>
                        <div class="input-row">
                            <div>
                                Abgeschirmtes Kabel
                            </div>
                            <div class="input-section">
                                <div>ca.</div>
                                <input type="number" name="shieldedCable" placeholder="Abgeschirmtes Kabel"
                                       [(ngModel)]="commissioningMaterial.shieldedCable">
                                <div class="input-unit">m</div>
                            </div>
                        </div>
                        <div class="input-row">
                            <div>
                                Leerrohr
                            </div>
                            <div class="input-section">
                                <div>ca.</div>
                                <input type="number" name="emptyConduit" placeholder="Leerrohr"
                                       [(ngModel)]="commissioningMaterial.emptyConduit">
                                <div class="input-unit">m</div>
                            </div>
                        </div>
                        <div class="input-row">
                            <div>
                                Abzweigdosen
                            </div>
                            <div class="input-section">
                                <div>ca.</div>
                                <input type="number" name="junctionBoxes" placeholder="Abzweigdosen"
                                       [(ngModel)]="commissioningMaterial.junctionBoxes">
                                <div class="input-unit">Stück</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="verification-row">
                <div class="input-group">
                    <label class="" [for]="'site'">Überprüfung ausgewählte Liegenschaft</label>

                    <ng-select [name]="'site'"
                               [id]="'site'"
                               required
                               [clearable]="false"
                               [(ngModel)]="selectedSite"
                               [compareWith]="compareById">
                        <ng-option
                                *ngFor="let site of (siteOptions || [])"
                                [value]="site">{{ getSiteName(site) }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <div class="verification-row">
                <div class="input-group">
                    <label class="" [for]="'technicianEmail'">Servicetechniker Montage*</label>

                    <ng-select [name]="'technicianEmail'"
                               [id]="'technicianEmail'"
                               required
                               [clearable]="true"
                               [(ngModel)]="technicianEmail"
                               #technicianEmailModel="ngModel">
                        <ng-option *ngFor="let technician of availableTechnicians.sort()"
                                   [value]="technician">{{ technician }}
                        </ng-option>
                    </ng-select>
                    <div class="error">
                                <span *ngIf="showError(technicianEmailModel)">
                                    Servicetechniker Montage muss ausgewählt werden.
                                </span>
                    </div>
                </div>
            </div>

            <div class="verification-row">
                <div class="input-group">
                    <label class="" [for]="'installationAt'">Montage Datum</label>

                    <input name="installationAt"
                           id="installationAt"
                           type="date"
                           [(ngModel)]="installationAt"
                           (ngModelChange)="installationDateChanged($event)"
                           [max]="maxIntallationDate"
                           #installationAtModel="ngModel"/>
                </div>
            </div>

            <div class="verification-row">
                <app-input-check-box name="verificationSuccessful"
                                     [(ngModel)]="verificationSuccessful"
                                     required>
                    <span>Überprüfung erfolgreich.</span>
                </app-input-check-box>
            </div>

            <div class="bottom-footer-container">
                <div class="input-group">
                    <label for="signature">Name Unterschrift</label>
                    <div class="unit-a"
                         [ngClass]="{ 'has-error': showError(signatureModel) }">
                        <input name="signature"
                               id="signature"
                               type="text"
                               [(ngModel)]="signature"
                               #signatureModel="ngModel"
                               placeholder="Eingabe..."/>
                    </div>
                    <div class="error">
                                <span *ngIf="showError(signatureModel)">
                                    Name Unterschrift ist ein Pflichtfeld.
                                </span>
                    </div>
                </div>

                <div class="signature-pad-container">
                    <div class="label">Unterschrift</div>

                    <div class="signature-preview"
                         [ngClass]="{ error: showSignatureError }">
                        <img *ngIf="signImage"
                             [src]="signImage"
                             alt=""/>
                    </div>

                    <button type="button"
                            class="secondary zoom"
                            (click)="openSignaturePad()">
                        <i class="juc ju-expand_screen"></i>
                        Unterschrift bearbeiten
                    </button>
                    <button type="button"
                            class="secondary clear"
                            (click)="clearSignaturePad()">
                        <i class="juc ju-delete"></i>
                        <!--                                Signatur löschen-->
                        Löschen
                    </button>
                </div>

                <div class="backdrop"
                     *ngIf="isSignPadVisible"
                     (click)="closeSignaturePad()">

                </div>
                <div class="zoomed-sign-pad-container"
                     [ngStyle]="{ 'width.px': signPadWidth, 'height.px': signPadHeight  }"
                     [ngClass]="{ hidden: !isSignPadVisible }">

                    <canvas #signaturePad
                            class="signature-pad"
                            [width]="signPadWidth - 33"
                            [height]="signPadHeight - 16 - 60"></canvas>
                    <div class="pad-footer">
                        <button type="button"
                                class="secondary signature-pad-button"
                                (click)="closeSignaturePad()">
                            <i class="juc ju-check"></i>Speichern
                        </button>
                        <button type="button"
                                class="secondary signature-pad-button"
                                (click)="clearSignaturePad()">
                            <i class="juc ju-delete"></i>Signatur löschen
                        </button>
                    </div>
                </div>

                <div class="input-group signature-date">
                    <label for="signature">Datum Unterschrift</label>
                    <div *ngIf="getSignatureDate() !== undefined" class="date">
                        {{ getSignatureDate() | date : "dd.MM.YYYY, HH:mm" }} Uhr
                    </div>
                    <div *ngIf="getSignatureDate() === undefined" class="date">-</div>
                </div>
            </div>

            <div class="action-row">
                <button class="primary"
                        (click)="submit()"
                        [disabled]="!isFormValid()">
                    Absenden
                    <span class="button-overly" (click)="checkForm(form)"></span>
                </button>
            </div>
        </form>
    </div>
</div>
